import swal from "sweetalert";
import { toast } from "react-toastify";

// Shown when the operator picks a downtime reason configured with "End Current Job" in the
// Downtime Reason master, so they know the running job will be ended before they save.
export function alertReasonEndsRunningJob(reason, multipleMachines = false) {
  const where = multipleMachines ? "on the selected machines" : "on this machine";
  swal({
    title: "Running Job Will End",
    text: `"${reason}" ends the running job. If a job is running ${where}, it will end at the downtime start time. If the job started at the same time as this downtime, the job will be deleted.`,
    icon: "info",
    button: "OK",
  });
}

const JOB_TOAST_OPTIONS = { position: "bottom-right", autoClose: 8000, closeOnClick: true, pauseOnHover: true };

// Tells the user what the server did with the running job after a downtime save. Takes
// the jobResult(s) the save returned: one object, an array, or nothing. A toast is used so
// it does not replace the save's own success alert.
//
// Returns true when a job was ended or deleted. The screens only patch the saved reason
// into their local state, so they must reload the machine activity to show the job change.
export function notifyJobResults(jobResults) {
  const results = [].concat(jobResults || []).filter(Boolean);
  results.forEach((one) => {
    if (one.Action === "Deleted") {
      toast.warning(`Job ${one.JobNumber} on ${one.Equipment} was deleted because it started at the same time as this downtime.`, JOB_TOAST_OPTIONS);
    } else if (one.Action === "Ended") {
      toast.info(`Job ${one.JobNumber} on ${one.Equipment} was ended at the downtime start time.`, JOB_TOAST_OPTIONS);
    } else if (one.Action === "Failed") {
      toast.error(`The running job on ${one.Equipment} could not be ended: ${one.Message}`, { ...JOB_TOAST_OPTIONS, autoClose: false });
    }
  });
  return results.some((one) => one.Action === "Deleted" || one.Action === "Ended");
}

// multipleDowntime returns one result per downtime, each carrying its own jobResult.
export function notifyMultipleJobResults(data) {
  return notifyJobResults((data?.results || []).map((one) => one.jobResult));
}
